import { removeClass }      from "./helpers";
import type { InertiaForm } from "@inertiajs/vue3";
import type { RouteParams } from "ziggy-js";

const reactiveForm = (e : Event, form : InertiaForm<any>, formEl : HTMLElement, routeS : string, routeParams : RouteParams<string> = {}) : void => {
    if ((e.target as HTMLFormElement).checkValidity()) {
        form.post(
            route(routeS, routeParams), {
                onSuccess: () => {
                    form.clearErrors();
                    removeClass('was-validated', formEl);

                    if ('name' in form) {
                        form.name = null;
                    }

                    if ('image' in form) {
                        form.image = null;
                    }

                    if ('url' in form) {
                        form.url = null;
                    }
                }
            }
        );
    }
};

export { reactiveForm };
